import React from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { SupervisorLogin } from '../../components/SupervisorLogin'
import { useReceivement } from '../../hooks/useReceivement'
import { useSearchParameters } from '../../hooks/useSearchParameters'
import { setReceivementSupervisor } from '../../services/receivement/receivementService'

const SupervisorLoginPage = () => {
  const history = useHistory()
  const { setSupervisorBadge } = useReceivement()
  const { next, receivementId } = useSearchParameters(['next', 'receivementId'])

  const handleInput = async (badge) => {
    if (receivementId) {
      const result = await setReceivementSupervisor(badge, receivementId)

      if (!result.isOk) {
        toast.error('Falha ao adicionar o supervisor ao recebimento!')
        return
      }
    }
    setSupervisorBadge(badge)
    history.push(next)
  }

  return (
    <SupervisorLogin
      title="Por favor, chame o supervisor antes de prosseguir"
      handleBadgeInput={handleInput}
    />
  )
}

export default SupervisorLoginPage
